var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5001 9.1838C7.4532 9.1838 6.44917 8.76792 5.70889 8.02764C4.96862 7.28737 4.55273 6.28334 4.55273 5.23643C4.55273 4.18952 4.96862 3.1855 5.70889 2.44522C6.44917 1.70494 7.4532 1.28906 8.5001 1.28906C9.54701 1.28906 10.551 1.70494 11.2913 2.44522C12.0316 3.1855 12.4475 4.18952 12.4475 5.23643C12.4475 6.28334 12.0316 7.28737 11.2913 8.02764C10.551 8.76792 9.54701 9.1838 8.5001 9.1838Z",
    stroke: "#183171",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.605469 19.7098V18.394C0.605469 16.9981 1.15998 15.6594 2.14701 14.6724C3.13405 13.6854 4.47275 13.1309 5.86863 13.1309H11.1318C12.5277 13.1309 13.8664 13.6854 14.8534 14.6724C15.8404 15.6594 16.3949 16.9981 16.3949 18.394V19.7098",
    stroke: "#183171",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.a4da9d623aa7ee4396b3e1a01a7d90a2.svg";
export { ForwardRef as ReactComponent };